import React, { useState, useEffect } from "react";
import { Box, Typography, CardMedia, Icon, Button, useMediaQuery, Dialog, DialogTitle, DialogContent, CircularProgress } from "@mui/material";
import BasicIcon from "../assets/PricePlanIcon/BasicIcon.png";
import PremiumIcon from "../assets/PricePlanIcon/PremiumIcon.png";
import { useWorkspace } from "../contexts/WorkspaceContext";
import { useNavigate } from "react-router-dom";
import CommonToast from "./Common_Components/CommonToast";
import { useAuth } from "../contexts/AuthContext";
import { handleAddCredit } from "../contexts/WorkspaceUtils";

const PricePageCards = ({callPlace}) => {
     const [selectedPlan, setSelectedPlan] = useState("Monthly");
      const [isLoading, setIsLoading] = useState(false);
      const [open, setOpen] = useState(false)
      const [content, setContent] = useState(null)
      const [iconType, setIconType] = useState(null)
      const [bgColor, setBgColor] = useState(null);
      const isBelow991 = useMediaQuery("(max-width:991px)");
      const navigate = useNavigate();
      const isLoggedIn = localStorage.getItem("isLoggedIn");
      const {subscribe, subscribeType} = useWorkspace()

    
      const onClose = () =>{
        setOpen(false);
      }
    
      useEffect(()=>{
        if(!isLoggedIn && !subscribe){
          setSelectedPlan("Monthly")
        }else if(isLoggedIn && subscribe){
          setSelectedPlan("Annual")
        }
      },[isLoggedIn])
    
    const ProPlanArray = [
        "Unlimited access to AI tools",
        "Advanced AI models",
        "Unlimited video generation",
        "Unlimited image generation",
        "Unlimited audio generation",
        "Unlimited presentation generation",
        "Track up to 15 websites",
        "Create & Host your website"
      ];
    
      const MonthlySMBmaxPlanArray = [
        "Hire AI calling agents for your business",
        "1000 minutes of calling credit",
        "Access to a relationship manager",
        "Personal AI Avatar with 25 credits",
        "+ Everything in Pro"
      ];
    
      const MonthlySMBmaxManagedPlanArray = [
        "Professional social media management",
        "High-quality content, posted consistently",
        "+ Everything in SMB Max"
      ];
        
 
    
       const HandleMonthlyProPlanButtonClick =async (e) => {
          e.stopPropagation()
          if(isLoggedIn){
            // const res = await handleAddCredit(setIsLoading, "1")
            const res = await handleAddCredit(setIsLoading, "pro")

          }else{
            setContent("Please SignUp or Login ");
            setIconType('error')
            setBgColor("#282D51")
            setOpen(true)
            // setShowSignUpModal(true)
            navigate('/signup')
          }
        };
    
    
       const HandleMonthlySMBMaxPlanButtonClick =async (e) => {
          e.stopPropagation()
          if(isLoggedIn){
            // const res = await handleAddCredit(setIsLoading, "4")
            const res = await handleAddCredit(setIsLoading, "smbmax")

          }else{
            setContent("Please SignUp or Login ");
            setIconType('error')
            setBgColor("#282D51")
            setOpen(true)
            // setShowSignUpModal(true)
            navigate('/signup')
          }
        };
    
    
        const HandleMonthlySMBMaxManagedButtonClick =async (e) => {
          e.stopPropagation()
          if(isLoggedIn){
            // const res = await handleAddCredit(setIsLoading, "5")
            const res = await handleAddCredit(setIsLoading, "smbmaxmanaged")

          }else{
            setContent("Please SignUp or Login ");
            setIconType('error')
            setBgColor("#282D51")
            setOpen(true)
            // setShowSignUpModal(true)
            navigate('/signup')
          }
        };
    
        const handleBookCall = () => {
          window.open("https://calendly.com/makarand-modalx", "_blank");
        };
    
        const handleEmailClick = (e) => {
          e.preventDefault(); // Prevent default link behavior
          if(isBelow991){
            window.open("mailto:support@modalx.ai", "_blank");
          }else{
            window.open(`https://mail.google.com/mail/?view=cm&to=support@modalx.ai`, "_blank");
          }
        };
    
  return (
    <div>
          <Box
        sx={{
          display: "flex",
          flexDirection:  isBelow991 ? "column" : "row",
          columnGap: isBelow991 ? "0px" : "60px",
          rowGap: isBelow991 ? "40px" : "0px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Pro Plan Card */}
        <Box  onClick={(e)=>{e.stopPropagation()}}
          sx={{
            width: "360px",
            height: "700px",
            border:
              selectedPlan === "Basic"
                ? "1px solid #FFFFFF"
                : "1px solid rgba(255, 255, 255, 0.10)",
            background: "#1F233E",
            borderRadius: "16px",
            padding: "30px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "12px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "20px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "#FFFFFF",
                  }}
                >
                  Pro
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                  Explore how the power of AI can help you with your business
                  needs
                </Typography>
              </Box>
                    <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "flex-end",
                                margin: "30px 0px",
                              }}
                            >
                              <Typography
                                                sx={{
                                                  fontFamily: "Inter",
                                                  fontSize: "24px",
                                                  fontStyle: "normal",
                                                  fontWeight: 600,
                                                  lineHeight: "24px",
                                                  letterSpacing: "0.1px",
                                                  color: "#FFFFFF",
                                                  textDecoration: "line-through",
                                                  marginRight:"12px"
                                                }}
                                              >
                                                $199
                                              </Typography>
                              <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: "24px",
                                  fontStyle: "normal",
                                  fontWeight: 600,
                                  lineHeight: "24px",
                                  letterSpacing: "0.1px",
                                  color: "#FFFFFF",
                                }}
                              >
                                $99
                              </Typography>
                              <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: "16px",
                                  fontStyle: "normal",
                                  fontWeight: 500,
                                  lineHeight: "normal",
                                  letterSpacing: "0.1px",
                                  color: "rgba(255, 255, 255, 0.80)",
                                }}
                              >
                                /month
                              </Typography>
                            </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "16px",
                }}
              >
                {ProPlanArray.map((ele, index) => {
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        columnGap: "10px",
                      }}
                    >
                      <Box sx={{ height: "20px", width: "20px" }}>
                        <CardMedia
                          sx={{ height: "20px", width: "20px" }}
                          component="img"
                          image={BasicIcon}
                          alt="Loading"
                        />
                      </Box>
                      <Box sx={{ display: "flex", width: "370px" }}>
                        <Typography
                          sx={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                            letterSpacing: "0.1px",
                            color: "#FFFFFF",
                          }}
                        >
                          {ele}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
            <Box>
              <Button disabled={subscribe && ( subscribeType == 4 || subscribeType == 3 || subscribeType == 2 || subscribeType == 1)}
                onClick={HandleMonthlyProPlanButtonClick}
                sx={{
                  width: "100%",
                  height: "40px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 600,
                  textAlign: "center",
                  bgcolor: (subscribe && ( subscribeType == 4 || subscribeType == 3 || subscribeType == 2 || subscribeType == 1)) ? "rgba(40, 45, 81, 1)" : "#FFFFFF",
                  color: (subscribe && ( subscribeType == 4 || subscribeType == 3 || subscribeType == 2 || subscribeType == 1)) ? "#CAC4D0" : "#17182C",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: isLoggedIn ? "rgba(40, 45, 81, 1)" : "#CDCFDF",
                  },
                  "&.Mui-disabled": {
                    color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
                    bgcolor: subscribe ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
                  },
              }}
              >
              {
                !isLoggedIn
                  ? "Get started for Pro"
                  : !subscribe
                    ? (callPlace === "workspace" ? "Upgrade to Pro" : "Get started with Pro")
                    : (Number(subscribeType) < 1
                        ? (callPlace === "workspace" ? "Upgrade to Pro" : "Get started with Pro")
                        : subscribeType === 1
                          ? "Current Plan"
                          : "Get started with Pro")
              }
              </Button>
            </Box>
          </Box>
        </Box>

        {/* SMB max Plan Card */}
        <Box onClick={(e)=>{e.stopPropagation()}}
          sx={{
            width: "360px",
            height: "700px",
            border:  ( subscribeType == 2 || subscribeType == 1) || !subscribe ? "1px solid #F6BE6B" : "1px solid rgba(255, 255, 255, 0.10)",
            background: "#1F233E",
            borderRadius: "16px",
            padding: "30px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "12px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    columnGap: "12px",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontSize: "20px",
                      fontStyle: "normal",
                      fontWeight: 700,
                      lineHeight: "20px",
                      letterSpacing: "0.1px",
                      color: "#FFFFFF",
                    }}
                  >
                    SMB Max
                  </Typography>
                 {(subscribe && (subscribeType === 3 || subscribeType === 4)) ? null : <Box
                    sx={{
                      bgcolor: "rgba(246, 190, 107, 0.20)",
                      border: "1px solid #F6BE6B",
                      borderRadius: "4px",
                      margin: "0px",
                      padding: "0px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "24px",
                        letterSpacing: "0.1px",
                        color: "#F6BE6B",
                        padding: "2px 4px",
                        margin: "0px",
                      }}
                    >
                      Popular
                    </Typography>
                  </Box>}
                </Box>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                  Take your business growth to the next level with advanced AI
                  tools
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  margin: "30px 0px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "#FFFFFF",
                    textDecoration: "line-through",
                    marginRight:"12px"
                  }}
                >
                  $999
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "#FFFFFF",
                  }}
                >
                  $249
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "normal",
                    letterSpacing: "0.1px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                  /month
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "16px",
                }}
              >
                {MonthlySMBmaxPlanArray.map((ele, index) => {
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        columnGap: "10px",
                      }}
                    >
                      <Box sx={{ height: "20px", width: "20px" }}>
                        <CardMedia
                          sx={{ height: "20px", width: "20px" }}
                          component="img"
                          image={PremiumIcon}
                          alt="Loading"
                        />
                      </Box>
                      <Box sx={{ display: "flex", width: "370px" }}>
                        <Typography
                          sx={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                            letterSpacing: "0.1px",
                            color: "#FFFFFF",
                          }}
                        >
                          {ele}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
            <Box>
              <Button disabled={isLoggedIn && subscribe && (subscribeType == 3 || subscribeType == 4)}
                onClick={HandleMonthlySMBMaxPlanButtonClick}
                sx={{
                  width: "100%",
                  height: "40px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 600,
                  textAlign: "center",
                  bgcolor: "rgba(246, 190, 107, 1)",
                  color: "rgba(23, 24, 44, 1)",
                  borderRadius: "8px",
                  "&:hover": {
                        backgroundColor: "#ffd9aa", 
                  },
                  "&.Mui-disabled": {
                    color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
                     bgcolor: subscribe ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
                  },
                }}
              >
                {
                !isLoggedIn
                  ? "Get started for SMB Max"
                  : !subscribe
                    ? (callPlace === "workspace" ? "Upgrade to SMB Max" : "Get started with SMB Max")
                    : (( Number(subscribeType) < 3)
                        ? (callPlace === "workspace" ? "Upgrade to SMB Max" : "Get started with SMB Max")
                        : (subscribeType === 3)
                          ? "Current Plan"
                          : "Get started with SMB Max")
              }
              </Button>
            </Box>
          </Box>
        </Box>

        {/*  SMB max Managed Plan Card */}
        <Box onClick={(e)=>{e.stopPropagation()}}
          sx={{
            width: "360px",
            height: "700px",
            border: "1px solid rgba(255, 255, 255, 0.10)",
            background: "#1F233E",
            borderRadius: "16px",
            padding: "30px 25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "12px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "20px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "#FFFFFF",
                  }}
                >
                  SMB Max Managed
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                  Business growth to unprecedented heights with the limitless potential of cutting-edge AI tools
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  margin: "30px 0px",
                }}
              >

              <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "#FFFFFF",
                    textDecoration: "line-through",
                    marginRight:"12px"
                  }}
                >
                  $2499
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "#FFFFFF",
                  }}
                >
                  $499
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "normal",
                    letterSpacing: "0.1px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                  /month
                </Typography>
              
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "16px",
                }}
              >
                {MonthlySMBmaxManagedPlanArray.map((ele, index) => {
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        columnGap: "10px",
                      }}
                    >
                      <Box sx={{ height: "20px", width: "20px" }}>
                        <CardMedia
                          sx={{ height: "20px", width: "20px" }}
                          component="img"
                          image={PremiumIcon}
                          alt="Loading"
                        />
                      </Box>
                      <Box sx={{ display: "flex", width: "370px" }}>
                        <Typography
                          sx={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                            letterSpacing: "0.1px",
                            color: "#FFFFFF",
                          }}
                        >
                          {ele}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
            <Box>
              <Button  disabled={isLoggedIn && subscribe && ( subscribeType == 4)}
                onClick={HandleMonthlySMBMaxManagedButtonClick}
                sx={{
                  width: "100%",
                  height: "40px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 600,
                  textAlign: "center",
                  color: "rgba(246, 190, 106, 1)",
                  padding:"0px",
                  border:(isLoggedIn && subscribe && ( subscribeType == 4)) ? "" : "1px solid rgba(246, 190, 106, 1)",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#282D51",
                  },
                  "&.Mui-disabled": {
                    color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
                    bgcolor:subscribe && subscribeType == 4 ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
                  },
                }}
              >
                 {
                !isLoggedIn
                  ? "Get started for SMB Max Managed"
                  : !subscribe
                    ? (callPlace === "workspace" ? "Upgrade to SMB Max Managed" : "Get started with SMB Max Managed")
                    : (( Number(subscribeType) < 4 )
                        ? (callPlace === "workspace" ? "Upgrade to SMB Max Managed" : "Get started with SMB Max Managed")
                        : subscribeType === 4
                          ? "Current Plan"
                          : "Get started with SMB Max Managed")
              }
              </Button>
            </Box>
          </Box>
        </Box>

      </Box>

      <Box  sx={{ display: "flex", justifyContent: "center", margin: isBelow991 ? "36px 0px" : "48px 0px" }}>
        <Typography  
          sx={{
            fontFamily: "Inter",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "24px",
            letterSpacing: "0.1px",
            color: "#FFFFFF",
            textAlign:"center",
          }}
        >
            Have questions? {<br/>} 
          <span onClick={handleBookCall} style={{ textDecorationLine: "underline", cursor:"pointer" }}>Book a call with us</span>{isBelow991 && <br/>} 
          <span style={{margin:"0px 8px", opacity:0.8}}>{`OR`}</span>{isBelow991 && <br/>} 
          Contact us at <span onClick={handleEmailClick} style={{ textDecorationLine: "underline", cursor:"pointer", color: "#ffffff" }}>support@modalx.ai</span>
        </Typography>
      </Box>
       
      {/* for payment success */}

      <Dialog
        open={isLoading}
        disableBackdropClick
        disableEscapeKeyDown
        PaperProps={{ style: { padding: '20px', textAlign: 'center' } }}
      >
        <DialogTitle>{"Processing..."}</DialogTitle>
        <DialogContent>
          <CircularProgress />
          <Typography variant="h6" style={{ marginTop: '15px' }}>
            Wait!.. Do not refresh the screen.
          </Typography>
        </DialogContent>
      </Dialog>  
       <CommonToast open={open} onClose={onClose} content={content} iconType={iconType} bgColor={bgColor}/> 
    </div>
  )
}

export default PricePageCards